/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, Input, AfterViewInit, ElementRef, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { ReportNote } from 'src/app/model/report.note';
import { ReportNotesProvider } from 'src/app/providers';
import { Report, User } from '../../../../../../model';
import { LogService } from 'src/app/services';

@Component({
  selector: 'notes-info-content',
  templateUrl: 'notes-info-content.component.html',
  styleUrls: ['notes-info-content.component.scss']
})
export class ReportNotesInfoContentComponent implements OnInit, OnDestroy {
  @Input() hostElement: HTMLElement;
  report: Report;
  notes: ReportNote[] = [];
  isloading: boolean = false;

  constructor(
    private reportNoteProvider: ReportNotesProvider,
    private logService :LogService
  ) {}

  ngOnInit(): void {
    this.isloading = true;
    this.reportNoteProvider.getNotes(this.report.ID, 1)
      .subscribe(data => {
        if(data.success){
          this.notes = ReportNote.parseArray(data.result);
        }
        this.isloading = false;
      }, err => {
        this.isloading = false;
        this.logService.error(err);
      })
  }

  ngOnDestroy(): void {

  }

}
